import React from 'react';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import * as fn from '../../../../helper/uiFunctions';

const WorkflowLink = ({ action, formObject }) => {
    if (!action) {
        return null;
    }

    const actionParam = formObject.convertStrToKeyValue(action.actionParam || '');
    const documentTypeId = actionParam?.dtId || '';
    const documentId = actionParam?.dId || '';

    if (!documentTypeId || !documentId) {
        return null;
    }

    const url = fn.getShowDocumentLink(documentTypeId, documentId, "", 1);

    return (
        <a className="uiLink uiSpacerH5" href={url} target="_blank" rel="noreferrer">
            <SarasTrans value={action.actionLabel || ''} />
        </a>
    );
};

export default WorkflowLink;
